import { AfterViewInit, Component, Inject, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
import { UiHelper } from '@helpers/ui.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { StandingsDialogComponent } from './standings.dialog.component';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
import { UserHelper } from '@helpers/user.helper';
import { environment } from '@environments/environment';
import { PromotionService } from '@services/promotion.service';
import { isNaN } from 'lodash';
import { from, of, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'left-sport-menu-desktop',
  templateUrl: '../sharedTemplates/left-sport-menu.desktop.html',
})
export class LeftSportMenuDesktop implements AfterViewInit, OnInit {
  public sportsSvgList = sportsSvgList;
  favoriteList = [];
  mainData = [];
  _dayFilter = 300;
  lastReturned_dayFilter = 0;
  selectedLeagueData = [];
  subscription: Subscription;
  searchKeySubject = new Subject<any>();
  showSearchResults = false;
  filled = false;
  searchValue = new FormControl('');
  constructor(
    private _ApiService: ApiService,
    private _TranslateService: TranslateService,
    public _DataHelper: DataHelper,
    public _UserHelper: UserHelper,
    public _Router: Router,
    public _UiHelper: UiHelper,
    private _ActivatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public _PromotionService: PromotionService
  ) {
    this._DataHelper.LeagueDataListener.subscribe(x => {
      if (this._DataHelper.LeagueData != undefined) {
        this.selectedLeagueData = this._DataHelper.LeagueData;
      }
    });
    this._Router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.searchValue.setValue(''); // Route değiştiğinde searchValue sıfırlanır
    });
  }

  changeDayFilter(e) {
    // //console.log("changeDayFilter",e);
    // //console.log("this._dayFilter",this._dayFilter);
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;
    // this.getSports(e.value);

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }
  timeFilterChangedDesktop(e) {
    this._dayFilter = e;
    this.getSports(this._dayFilter);
  }

  selectedLeague(e, item2) {
    //console.log('--e--',e);
    //console.log('--item2--',item2);

    //console.log('-LEFT_MENU-selectedLeagueData--',this.selectedLeagueData);

    const ixoftor = this.selectedLeagueData.indexOf(x => x.TournamentId == e.source.value.TournamentId);

    //////console.warn(this.selectedLeagueData, e.source.value.TournamentId, ixoftor);

    if (this.selectedLeagueData.find(x => x.TournamentId == e.source.value.TournamentId) == undefined) {
      this.selectedLeagueData.push(e.source.value);
    } else {
      this.selectedLeagueData = this.selectedLeagueData.filter(x => x.TournamentId != e.source.value.TournamentId);
    }

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    if (!e.source.checked) {
      item2.allselected = false;
    }

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  goToSportSearch() {
    this._UiHelper.setSportInputStatus(true);
    this._DataHelper.preMatchobservable.next([]);
  }

  openLeague(sport, tournament, category) {
    this.selectedLeagueData = [];

    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: category.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  checkList(e) {
    return this.selectedLeagueData.find(x => x.TournamentId == e) != undefined;
  }

  selectedLeagueviaAll(e, sport, state) {
    // //console.log('selectedLeagueviaAll--',e)

    const cbData = {
      TournamentName: e.TournamentName,
      TournamentId: e.TournamentId,
      CategoryId: e.CategoryId,
      CategoryName: e.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    if (state) {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) == undefined) {
        this.selectedLeagueData.push(cbData);
      }
    } else {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) != undefined) {
        // this.selectedLeagueData.splice(this.selectedLeagueData.indexOf(x => x.TournamentId == e.TournamentId), 1);
        this.selectedLeagueData = this.selectedLeagueData.filter(x => x.TournamentId != e.TournamentId);
      }
    }
  }

  selectAll(e, cntrl, sport) {
    e.level.forEach(cb => {
      cb.checked = cntrl.source.checked;
      this.selectedLeagueviaAll(cb, sport, cntrl.source.checked);
    });

    if (cntrl.source.checked) {
      this._DataHelper.setLeagueData(this.selectedLeagueData);
    } else {
      // TEST
      this.selectedLeagueData = this.selectedLeagueData.filter(x => x.CategoryId != e.CategoryId);

      this._DataHelper.setLeagueData(this.selectedLeagueData); // e.CategoryId
    }
  }

  openAll(e, category, sport, i, k) {
    this.selectedLeagueData = [];

    e.level.forEach(cb => {
      const cbData = {
        TournamentName: cb.TournamentName,
        TournamentId: cb.TournamentId,
        CategoryId: category.CategoryId,
        CategoryName: category.CategoryName,
        SportId: sport.SportId,
        SportName: sport.SportName,
      };

      this.selectedLeagueData.push(cbData);
      this._DataHelper.setLeagueData(this.selectedLeagueData);
      this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
    });

    this.getTourementsByCountryID(sport.SportId, category.CategoryId, i, k);
    //openAll(mainData[i].level[k], item2, item);
  }

  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService.getSports(__dayFilter).then(x => {
        try {
          this.mainData = x.map(x => {
            x['level'] = [];
            x['loading'] = false;
            x['state'] = false;
            return x;
          });
          this.lastReturned_dayFilter = __dayFilter;
        } catch (error) {
          console.log('left-sports-menu.desktop', error);
        }
      });
    }
  }

  getCountriesBySportsID(_sportID, _index) {
    ////console.log(this.mainData[_index].level.length);
    if (this.mainData[_index].level.length == 0 && !this.mainData[_index].state) {
      this.mainData[_index]['loading'] = true;
      this._ApiService.getCountriesBySportsID(this._dayFilter, _sportID).then(x => {
        this.mainData[_index].level = x.map(x => {
          x['level'] = [];
          x['state'] = false;
          x['loading'] = false;
          x['allselected'] = false;
          return x;
        });
        this.mainData[_index]['loading'] = false;
        this.mainData[_index]['state'] = true;
      });
    } else if (this.mainData[_index].level.length != 0 && !this.mainData[_index].state) {
      this.mainData[_index]['state'] = true;
    } else {
      this.mainData[_index]['state'] = false;
    }
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
    this._DataHelper.liveHeaderTitle = _sportID?.sportName;
  }

  getTourementsByCountryID(_sportID, _countriesID, _index, _indexl2) {
    const currentItem = this.mainData[_index].level[_indexl2];
    //////console.log(currentItem);
    //////console.log(currentItem.level.length == 0, !currentItem.state);
    if (currentItem.level.length == 0 && !currentItem.state) {
      currentItem['loading'] = true;
      this._ApiService
        .getTourementsByCountryID(this._dayFilter, _sportID, _countriesID)
        .then(x => {
          currentItem.level = x.map(x => {
            x['checked'] = false;
            return x;
          });
          currentItem['loading'] = false;
          currentItem['state'] = true;
          currentItem['allselected'] = false;

          this._ApiService.getOutrightsByCountryID(this._dayFilter, _sportID, _countriesID).then(x => {
            currentItem.outrights = x.map(x => {
              x['checked'] = false;
              return x;
            });
          });
        })
        .catch(err => {
          console.log('left-sports-menu.desktop', err);
        });
    } else if (currentItem.level.length != 0 && !currentItem.state) {
      currentItem['state'] = true;
    } else {
      currentItem['state'] = false;
    }
    this.mainData[_index].level[_indexl2] = currentItem;
    //////console.log(this.mainData);
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  ngAfterViewInit() {
    this._TranslateService.instant('home_live');

    this._dayFilter = this._DataHelper.leftMenuSportDayFilter;
    this._ActivatedRoute.queryParams.subscribe(p => {
      if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();
    });
  }

  ngOnInit() {
    if (this._DataHelper.leftMenuSportData != undefined) {
      if (this._DataHelper.leftMenuSportData.length != 0) this.mainData = this._DataHelper.leftMenuSportData;
      else this.getSports();
    } else this.getSports();

    this.changeDayFilter({ source: null, value: this._DataHelper.leftMenuSportDayFilter });
    this.subscription = this.searchValue.valueChanges
      .pipe(
        debounceTime(500), // Kullanıcının yazmayı bırakmasının ardından 500ms bekler
        distinctUntilChanged(), // Sadece farklı arama terimleri için çalışır
        switchMap(term => {
          return from(this.getSearch(term)); // Promiseyi observable'a dönüştürür
        })
      )
      .subscribe(
        results => {
          this._DataHelper.setSearchData(results);
        },
        error => console.log('err', error)
      );
  }

  getSearch(term: string) {
    this._UiHelper.searchTerm = term;

    if (term && term.length >= 3) {
      return this._ApiService
        .getSearchp1001(term)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else if (term == '') {
      const searchKey = 'All';
      return this._ApiService
        .getSearchp1001(searchKey)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else {
      //Observable hatası almamak için manuel boş array atandı, 3 harften küçükse

      this._DataHelper.setSearchData([]);

      this._UiHelper.hasSearchData = false;
      return [];
    }
  }

  leagueSlider = [
    {
      FileName: 'angular/dist/assets/images/league/premiere.svg',
      route: '/league',
      TourId: '107',
      CatId: '1',
      LeagueName: 'Premier League',
      height: '30px',
    },
    {
      FileName: 'angular/dist/assets/images/league/Bundesliga_logo.svg',
      route: '/league',
      TourId: '16',
      CatId: '13',
      LeagueName: 'Bundesliga',
      height: '40px',
    },
    {
      FileName: 'angular/dist/assets/images/league/LaLiga.svg',
      route: '/league',
      TourId: '128',
      CatId: '15',
      LeagueName: 'La Liga',
      height: '25px',
    },
    {
      FileName: 'angular/dist/assets/images/league/serie-a-seeklogo.com.svg',
      route: '/league',
      TourId: '236',
      CatId: '14',
      LeagueName: 'Seria A',
      height: '35px',
    },
    {
      FileName: 'angular/dist/assets/images/league/spor_toto_super_lig_logo.svg',
      route: '/league',
      TourId: '133',
      CatId: '16',
      LeagueName: 'Super Lig',
      height: '35px',
    },
    {
      FileName: 'angular/dist/assets/images/league/Ligue_1_logo.svg',
      route: '/league',
      TourId: '167',
      CatId: '99',
      LeagueName: 'Lique 1',
      height: '35px',
    },
  ];

  getFav(matchInfo) {
    if (matchInfo.checked == true) {
      matchInfo.checked = false;
    } else {
      this.favoriteList.push(matchInfo);
      localStorage.setItem('favorited', JSON.stringify(this.favoriteList));
      matchInfo.checked = true;
    }
    //Favori Mantığı kontrol edin
    this.favoriteList = [];
  }

  add2TournamentFavs(tour, cat) {
    const favitem = {
      tourid: tour.TournamentId,
      tourname: tour.TournamentName,
      catid: cat.CategoryId,
      catname: cat.CategoryName,
      count: tour.TournamentSportEventCount,
    };
    tour['checked'] = !tour['checked'];
    this._UiHelper.favTournamentChanged(favitem);
  }

  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;
  isOpenMyTeamMenu = true;

  toggleMyTeamMenu() {
    this.isOpenMyTeamMenu = !this.isOpenMyTeamMenu;
  }
  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  openStats(e) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: '',
        type: e,
      },
    });
  }

  getSelectedMyTeamFixture(teamId) {
    this._UiHelper.setLoadingDialog(true);
    let sID = '0';
    let cID = '-1';
    let tID = '0';

    if (teamId === -1) {
      sID = '0';
      cID = '-2';
      tID = this._UserHelper.customerUser.CustomerId;
    } else {
      sID = '0';
      cID = '-1';
      tID = teamId;
    }

    this._ApiService
      .getFixture(sID, cID, tID)
      .then(x => {
        this._DataHelper.preMatchobservable.next(x);

        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }

        this._UiHelper.setLoadingDialog(false);
      })
      .catch(err => console.log('sports', err));
  }

  onSearchClick() {
    this.searchKeySubject.next();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value;
    this.searchValue.setValue(searchTerm);
  }

  protected readonly environment = environment;
  protected readonly isNaN = isNaN;
}
